import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Format from '..';

class DateFormat extends Component {
  constructor(props) {
    super(props);

    this.state = DateFormat.getComponentState(props);
  }

  static getComponentState(props) {
    let date = Date.parse(props.date) || props.date;
    if (!date) {
      // eslint-disable-next-line no-console
      console.error(
        "FacetDateLongFormat requires property 'date'. In order to prevent further errors we've supplied the current date, but you should change this.",
      );
      date = Date.now();
    }
    return {
      date: new Date(date),
    };
  }

  getFormat(date) {
    const { format } = this.props;
    return date.toLocaleString('en-US', format);
  }

  render() {
    const { className } = this.props;
    const { date } = this.state;
    return (
      <Format className={`Date ${className}`.trim()}>
        {this.getFormat(date)}
      </Format>
    );
  }
}

DateFormat.propTypes = {
  className: PropTypes.string,
  format: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

DateFormat.defaultProps = {
  className: '',
};

export default DateFormat;
